import { useParams } from "react-router-dom";
import { ProjectsDetail } from "../components/ProjectsDetail";

const DetailProjects = () => {
  const {id} = useParams();
  return (
    <>
        <div id="card-content">
          <div className="row">
              <div className="card card-2 mmb-7 mt-3 ml-auto mr-auto">
                <div className="card-body">
                    <div className="p-4">
                        <ProjectsDetail projectId={id} />
                    </div>
                </div>
              </div>
          </div>
        </div>
    </>
  );
}
export default DetailProjects;